import { toast } from 'react-toastify';

/**
 * Standard API Response Shape:
 * 
 * Success Response:
 * {
 *   "success": true,
 *   "status": 800,
 *   "message": "Success",
 *   "data": {}
 * }
 * 
 * Error Response:
 * {
 *   "success": false,
 *   "status": 400,
 *   "message": "Error message",
 *   "data": null
 * }
 */

/**
 * Standardizes any API response object, Axios response, or error payload into:
 * { success: boolean, status: number, message: string, data: any }
 */
export const parseApiResponse = (response) => {
  if (!response) {
    return {
      success: false,
      status: 400,
      message: 'Hakuna jibu lililopokelewa kutoka kwa mfumo',
      data: null
    };
  }

  // Handle Axios response or Error objects where payload is in response.response.data or response.data
  let res = response;
  if (response.response && response.response.data && typeof response.response.data === 'object') {
    res = response.response.data;
  } else if (response.data && typeof response.data === 'object') {
    if (
      response.data.success !== undefined ||
      response.data.status !== undefined ||
      response.data.message !== undefined
    ) {
      res = response.data;
    }
  }

  // Determine success status (status === 800, 200, 201 or explicit success === true)
  const isSuccess =
    res.success === true ||
    res.status === 800 ||
    res.status === 200 ||
    res.status === 201;

  const status = res.status !== undefined ? Number(res.status) : (isSuccess ? 800 : 400);

  // Extract and format message
  let message = res.message || response.message;
  if (!message) {
    message = isSuccess ? 'Success' : 'Hitilafu imetokea katika mfumo';
  } else if (typeof message === 'object') {
    if (Array.isArray(message)) {
      message = message.join(', ');
    } else {
      message = Object.values(message).flat().join(', ');
    }
  }

  const data = res.data !== undefined ? res.data : null;

  return {
    success: Boolean(isSuccess),
    status,
    message: String(message),
    data,
    raw: res
  };
};

/**
 * Global helper function to display toast notification based on API payload
 * @param {Object} payload - API response payload, error object, or standard response object
 * @param {Object} [options] - Options e.g. { showSuccessToast: true, showErrorToast: true }
 */
export const showApiMessage = (payload, options = {}) => {
  const parsed = parseApiResponse(payload);

  if (parsed.success) {
    if (options.showSuccessToast !== false) {
      toast.success(parsed.message);
    }
  } else {
    if (options.showErrorToast !== false) {
      toast.error(parsed.message);
    }
  }

  return parsed.success;
};

/**
 * Helper function to handle and unwrap standard API responses across all admin modules
 * Returns boolean `isSuccess` for simple conditional checks
 */
export const handleApiResponse = (response, options = {}) => {
  return showApiMessage(response, options);
};

const ApiMessageModal = () => null;

export default ApiMessageModal;
